/*
 * @Author: your name
 * @Date: 2020-11-24 09:33:11
 * @LastEditTime: 2021-07-08 14:50:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/mudules/localStorage.js
 */

import {
  GET_SIGN_UP_POPUP_ONCE_TIME,
  SET_SIGN_UP_POPUP_ONCE_TIME
} from './mutations'

// initial state
const state = () => ({
  popupTime: ''
})

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
  [GET_SIGN_UP_POPUP_ONCE_TIME](state) {
    let signUpDialogOnceTime
    try {
      signUpDialogOnceTime = JSON.parse(localStorage.getItem('signUpDialogOnceTime') ?? '{}')
    } catch (error) {
      signUpDialogOnceTime = {}
    }
    state.popupTime = signUpDialogOnceTime
  },

  [SET_SIGN_UP_POPUP_ONCE_TIME](state, {
    nowTime,
    venueId
  }) {
    let signUpDialogOnceTime
    try {
      signUpDialogOnceTime = JSON.parse(localStorage.getItem('signUpDialogOnceTime') ?? '{}')
    } catch (error) {
      signUpDialogOnceTime = {}
    }
    signUpDialogOnceTime[venueId] = nowTime
    localStorage.setItem('signUpDialogOnceTime', JSON.stringify(signUpDialogOnceTime))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}